// @ts-nocheck
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import filterViewerFromAttendees from 'helpers/filterViewerFromAttendees'

import HideVisually from 'js/components/HideVisually/HideVisually'
import People from 'js/components/People'

import AttendeesModal from './components/AttendeesModal'
import styles from './EventAttendees.module.css'

const EventAttendeesButton = ({ total, label, onClick }) => {
    const { t } = useTranslation()

    return (
        <button
            className={styles.attendeesColumn}
            type="button"
            onClick={onClick}
        >
            <div className={styles.attendeesNumber} aria-hidden>
                {total}
            </div>
            <div className={styles.attendeesStatus} aria-hidden>
                {label}
            </div>
            <HideVisually>
                {t('entity-event.view-attendees')} ({total} {label})
            </HideVisually>
        </button>
    )
}

const EventAttendees = ({ entity, viewer }) => {
    const {
        attendees,
        isAttending,
        rsvp,
        attendEventWithoutAccount,
        enableMaybeAttendEvent,
        attendEventOnline,
    } = entity
    const { totalAccept, totalMaybe, totalOnline, totalReject } = attendees
    const { loggedIn } = viewer

    const { t } = useTranslation()

    const [attendeesModal, setAttendeesModal] = useState(false)

    if (!loggedIn || (loggedIn && !rsvp && !attendEventWithoutAccount)) {
        return null
    }

    return (
        <div>
            <People
                tabIndex="-1"
                as="button"
                type="button"
                onClick={() => setAttendeesModal('going')}
                showCheck={isAttending === 'accept'}
                checkLabel={t('entity-event.you-are-going')}
                users={
                    isAttending === 'accept'
                        ? filterViewerFromAttendees(
                              attendees.edges,
                              viewer.user.guid,
                          )
                        : attendees.edges
                }
                total={totalAccept}
                size="large"
                className={styles.attendeesPeople}
                aria-hidden
            />

            <div className={styles.attendeesColumns}>
                <EventAttendeesButton
                    total={totalAccept}
                    label={t('entity-event.going')}
                    onClick={() => setAttendeesModal('going')}
                />

                {attendEventOnline && (
                    <EventAttendeesButton
                        total={totalOnline}
                        label={t('entity-event.online')}
                        onClick={() => setAttendeesModal('online')}
                    />
                )}

                {enableMaybeAttendEvent && (
                    <EventAttendeesButton
                        total={totalMaybe}
                        label={t('entity-event.maybe')}
                        onClick={() => setAttendeesModal('maybe')}
                    />
                )}

                <EventAttendeesButton
                    total={totalReject}
                    label={t('entity-event.not-going')}
                    onClick={() => setAttendeesModal('not-going')}
                />
            </div>

            <AttendeesModal
                tab={attendeesModal}
                setTab={setAttendeesModal}
                entity={entity}
            />
        </div>
    )
}

export default EventAttendees
